import { animate, state, style, transition, trigger } from '@angular/animations';

export const bumpIn = trigger('pressState', [
  state('down', style({ transform: 'scale(0.97)' })),
  state('up', style({ transform: 'scale(1)' })),
  transition('up => down', animate('100ms ease-out')),
  transition('down => up', animate('100ms ease-in')),
]);

export const slide = trigger('slideAnimation', [
  transition(':increment', [
    style({ transform: 'translateX(100%)' }), // Заходит с правой стороны
    animate('700ms ease', style({ transform: 'translateX(0)' })),
    style({ display: 'none' }),
  ]),
  transition(':decrement', [
    style({ transform: 'translateX(-100%)' }), // Уходит с текущего положения
    animate('700ms ease', style({ transform: 'translateX(0)' })),
  ]),
]);
